import { Repository } from "src/firebase/firestore/repository";
import { UserTransaction } from "./types/user-transaction.entity";

export class UserTransactionRepository extends Repository<UserTransaction> {
  constructor() {
    super("users_transactions");
  }
}

export const userTransactionRepository = new UserTransactionRepository();
